import { useEffect, useState } from "react";

const AnimatedDisplay = ({ value, fixedWidth }) => {
  const [displayValue, setDisplayValue] = useState("");
  const isNumber = typeof value === "number";

  useEffect(() => {
    let animationFrame;
    let start;

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    if (isNumber) {
      const animate = (timestamp) => {
        if (!start) start = timestamp;
        const elapsed = timestamp - start;
        const progress = Math.min(elapsed / 500, 1);
        const eased = easeOutCubic(progress);
        const current = Math.round(eased * value);
        setDisplayValue(current);
        if (progress < 1) {
          animationFrame = requestAnimationFrame(animate);
        }
      };
      animationFrame = requestAnimationFrame(animate);
    } else {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const textLength = value?.length || 5;

      const animateText = (timestamp) => {
        if (!start) start = timestamp;
        const elapsed = timestamp - start;
        const progress = Math.min(elapsed / 500, 1);
        const stableCount = Math.floor(progress * textLength);
        const randomText = Array.from({ length: textLength }, (_, i) =>
          i < stableCount
            ? value[i]
            : chars.charAt(Math.floor(Math.random() * chars.length))
        ).join("");
        setDisplayValue(progress < 1 ? randomText : value);
        if (progress < 1) {
          animationFrame = requestAnimationFrame(animateText);
        }
      };
      animationFrame = requestAnimationFrame(animateText);
    }

    return () => cancelAnimationFrame(animationFrame);
  }, [value]);

  return (
    <div
      className="tex-center "
      style={{
        width: fixedWidth ? fixedWidth : "60px",
        textAlign: "center",
        // fontFamily: "monospace",
        color: "#484848ff",
        fontSize: "15px",
        fontWeight: "bold",
        // whiteSpace: "nowrap",
      }}
    >
      {displayValue}
    </div>
  );
};

export default AnimatedDisplay;
